// extracted by mini-css-extract-plugin
export default {"settings_container":"Settings_settings_container__Imn46","settings_body":"Settings_settings_body__4hVFR"};